import { render } from "./InformacaoLi.vue?vue&type=template&id=3f833019"
import script from "./InformacaoLi.vue?vue&type=script&lang=js"
export * from "./InformacaoLi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__